import { FView } from '@/core/FView';
import { EnterExitDailyRecord } from '../EnterExitDailyRecord';
import { DataType } from '../../DataType';

export class EntranceVisitors {
    name!: string;
    passed!: number;

    public static getEntrancesVisitors(dataSet: EnterExitDailyRecord[]): EntranceVisitors[] {
        let resultSet: EntranceVisitors[] = [];

        for (let record of dataSet) {
            let existing = resultSet.find(rs => rs.name == record.address);
            if (existing != null) {
                existing.passed += record.in;
            } else {
                let entranceRecord: EntranceVisitors = {
                    name: record.address,
                    passed: record.in
                }
                resultSet.push(entranceRecord);
            }
        }

        return resultSet;
    }
}
